export interface SerpProgressAnalysisGq {
  serpRequestId: number;
  keywordCount?: number;
  volumeSum?: number;
  trafficSum: number;
  averageRank: number;
  weightedAverageRank: number;
  rank_1_3_count: number;
  rank_4_10_count: number;
  rank_11_20_count: number;
  rank_21_50_count: number;
  rank_51_100_count: number;
  rank_101_count: number;
  rank_1_3_volume: number;
  rank_4_10_volume: number;
  rank_11_20_volume: number;
  rank_21_50_volume: number;
  rank_51_100_volume: number;
  rank_101_volume: number;
  domainId?: number;
  tagId?: number;
  tagGroupId?: number;
}

export const emptySerpProgressAnalysis: SerpProgressAnalysisGq = {
  serpRequestId: 0,
  keywordCount: 0,
  volumeSum: 0,
  trafficSum: 0,
  rank_101_count: 0,
  rank_101_volume: 0,
  rank_11_20_count: 0,
  rank_11_20_volume: 0,
  rank_1_3_count: 0,
  rank_1_3_volume: 0,
  rank_21_50_count: 0,
  rank_21_50_volume: 0,
  rank_4_10_count: 0,
  rank_4_10_volume: 0,
  rank_51_100_count: 0,
  rank_51_100_volume: 0,
  averageRank: 100,
  weightedAverageRank: 100,
};

export const SerpProgressAnalysisGqProps = `
    serpRequestId
    keywordCount
    volumeSum
    trafficSum
    averageRank
    weightedAverageRank
    rank_1_3_count
    rank_4_10_count
    rank_11_20_count
    rank_21_50_count
    rank_51_100_count
    rank_101_count
    rank_1_3_volume
    rank_4_10_volume
    rank_11_20_volume
    rank_21_50_volume
    rank_51_100_volume
    rank_101_volume
    domainId
    tagId
    tagGroupId
`;
